export const NAME = 'associateRatesToReference';
export const LEVEL_ONE = 'AssociateRatesToReferenceComponentReducer';
